import { render } from "./OrderPartialDetailsShipping.vue?vue&type=template&id=73b5c368"
import script from "./OrderPartialDetailsShipping.vue?vue&type=script&lang=js"
export * from "./OrderPartialDetailsShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__